import { UploadFile } from 'antd/es/upload/interface';

export enum SupportTicketType {
  BUG = 'bug',
  FEATURE_REQUEST = 'feature_request',
  SUPPORT = 'support',
}

export type TSupportTicketFormValues = {
  type: SupportTicketType;
  title: string;
  description: string;
  attachments?: UploadFile[];
};

export type TSupportTicketResponse = {
  ticketKey: string;
  ticketUrl: string;
  status: string;
  message: string;
};

export type THelpSupportModalProps = {
  visible: boolean;
  onClose: () => void;
};
